import { useState } from "react";
import { Box } from "@mui/material";
import { AssetTableComponent } from "../../asset-table/asset-table-component";
import { TicketTableComponent } from "../../tickets-table/ticket-table-component";
import { TicketTableContextProvider } from "@hooks/use-table-context/ticket";
import { AddAssetModal } from "../../asset-table/add-asset-modal";
import { AddTicketModal } from "../../tickets-table/add-ticket-modal";
import { AssetTableContextProvider } from "@hooks/use-table-context/asset";
import { UserTableContextProvider } from "@hooks/use-table-context/user";
import { UsersTableComponent } from "@views/users-table/users-table-component";
import { AddUserModal } from "@views/users-table/add-user-modal";

export const AssetTableWidget = ({ id }: { id: string }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  const handleOpenModal = (data?: any) => {
    setEditData(data?.id ? data : null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditData(null);
  };

  return (
    <AssetTableContextProvider instanceId={id}>
      <Box sx={{ display: "flex", minWidth: 0 }}>
        <AssetTableComponent
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            mx: "auto",
            "& .MuiTableContainer-root ": {
              maxHeight: "270px",
            },
          }}
          openAssetModal={handleOpenModal}
        />
        <AddAssetModal
          key={editData?.id || "new"}
          open={isModalOpen}
          onClose={handleCloseModal}
          editData={editData}
        />
      </Box>
    </AssetTableContextProvider>
  );
};

export const TicketTableWidget = ({ id }: { id: string }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  const handleOpenModal = (data?: any) => {
    setEditData(data?.id ? data : null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setIsModalOpen(false);
  };

  return (
    <TicketTableContextProvider instanceId={id}>
      <Box sx={{ display: "flex", minWidth: 0 }}>
        <TicketTableComponent
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            mx: "auto",
            "& .MuiTableContainer-root ": {
              maxHeight: "270px",
            },
          }}
          openTicketModal={handleOpenModal}
        />
        <AddTicketModal
          key={isModalOpen ? (editData?.id || "new") : "closed"}
          open={isModalOpen}
          onClose={handleCloseModal}
          editData={editData}
        />
      </Box>
    </TicketTableContextProvider>
  );
};

export const UserTableWidget = ({ id }: { id: string }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  const handleOpenModal = (data?: any) => {
    setEditData(data?.id ? data : null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setIsModalOpen(false);
  };

  return (
    <UserTableContextProvider instanceId={id}>
      <Box sx={{ display: "flex", minWidth: 0 }}>
        <UsersTableComponent
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            mx: "auto",
            "& .MuiTableContainer-root ": {
              maxHeight: "270px",
            },
          }}
          openUserModal={handleOpenModal}
        />
        <AddUserModal
          key={isModalOpen ? (editData?.id || "new") : "closed"}
          open={isModalOpen}
          onClose={handleCloseModal}
          editData={editData}
        />
      </Box>
    </UserTableContextProvider>
  );
};